import React from "react";
import "./Square.css";
import rapperImageLoader from "../../../utils/helperFunctions.js";

function Square(props) {
  //checks if square has prop type='center', if so change class to square_center.
  let squareType = (type) => {
    if (type === "center") {
      return "square_center";
    } else {
      return "square"
    }
  }

  //return animations for different squares depending on position
  let squareAnimation = () => {
    if (props.rapper && props.rapper.name && (props.position < 8 || props.position > 22)) {
      return "animated flipInY"
    }
    else {
      return "animated fadeIn"
    }
  }

  //return proper type of square depending on position and status of bracket
  if (props.rapper) {
    if ((props.position > 8 && props.position < 23) || props.position === 31) {
      // console.log(props.rapper)
      return (
        <div className={`${squareType(props.type)} ${props.handleClassHighlight(props.position, props.rapper, props.origin, props.next)}`} onClick={() => props.handleSquareClick(props.position, props.origin, props.next)}>
          <img className={`square_image ${squareAnimation()}`} src={ rapperImageLoader(props.rapper.pic)} alt="Rapper"></img>
        </div>
      );
    }
    else {
      return (
        <div className={`${squareType(props.type)} animated ${props.handleClassHighlight(props.position, props.rapper, props.origin, props.next)} `} onClick={() => props.handleSquareClick(props.position, props.origin, props.next)}>
          <img className={`square_image_entry square_image ${squareAnimation()}`} src={ rapperImageLoader(props.rapper.pic)} alt="Rapper"></img>
        </div>
      );
    }

  }

  else if (squareType(props.type) === "square_center") {
    return (
      <div className={`${squareType(props.type)} ${props.handleClassHighlight(props.position, props.rapper, props.origin, props.next)}`} onClick={() => props.handleSquareClick(props.position, props.origin, props.next)}>
        <div ></div>
        <div className="name">{props.rapper && props.rapper.name}</div>
      </div>
    );
  }

  else {
    return (
      <div className={`${squareType(props.type)} ${props.handleClassHighlight(props.position, props.rapper, props.origin, props.next)}`} onClick={() => props.handleSquareClick(props.position, props.origin, props.next)}>
        <div className="square_image"></div>
        <div className="name">{props.rapper && props.rapper.name}</div>
      </div>
    );
  }
}

export default Square;
